exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".scope-written .multi-setting{border-top:1px solid #ddd;margin-top:15px}.scope-written .multi-setting .label{font-weight:700;margin:5px}.scope-written .multi-setting .betch-btn{background:url(" + require("../arrangement/betch-btn.png") + ") no-repeat 50%;width:40px;height:36px;display:inline-block;vertical-align:bottom}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1df79ac3","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/written/writtenRecommend.vue
// module id = 940
// module chunks = 23